<div
  class="sidebar-container"
  [ngClass]="{ 'collapse-sidebar': isSidebarCollapsed }"
>
  <div
    class="toggle-btn"
    (click)="toggleSidebar()"
    [ngClass]="{ 'collapsed-toggle-btn': isSidebarCollapsed }"
  >
    <i
      class="fa"
      [ngClass]="isSidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"
    ></i>
  </div>

  <div class="sidebar-wrapper">
    <div
      class="text-center d-flex align-items-center justify-content-center"
      style="height: 8.333vw !important"
      *ngIf="
        currentUrl == '/setup' ||
        currentUrl == '404' ||
        userRole != 'SuperAdmin'
      "
    >
      <div style="width: 11.181vw !important">
        <img
          id="sideBarLogo"
          [ngSrc]="logoImg"
          width="100"
          height="100"
          placeholder
          alt="logo"
        />
      </div>
    </div>
    <div
      class="w-100 d-flex justify-content-center mb-5-vw"
      *ngIf="
        userRole == 'SuperAdmin' &&
        currentUrl != '/setup' &&
        currentUrl != '404'
      "
    >
      <div class="circular-image">
        <img
          id="imageCursor sideBarLogo"
          [src]="
            imageUrl
              ? imageUrl
              : 'https://icon-library.com/images/generic-user-icon/generic-user-icon-9.jpg'
          "
          alt=""
          srcset=""
        />
      </div>
    </div>
    <div id="scrollableHeight">
      <ul class="list-unstyled mt-2-vw">
        <!-- Main Menu Items -->
        <ng-container *ngFor="let menu of sidebarMenu">
          <li
            *ngIf="menu.isVisible && menu.userRole?.includes(userRole)"
            (click)="
              menu.isToggleMenu
                ? (menu.subMenuVisible = !menu.subMenuVisible)
                : routeChange(menu.routerLink);
              menu.routerLink ? routeChange(menu.routerLink) : ''
            "
            class="fs-13-vw fw-600 d-flex align-items-center"
            [class.active]="isActive(menu?.routerLink)"
            [ngClass]="{ activeeleemnt: menu.subMenuVisible }"
          >
            <div class="ms-3-vw me-2-vw">
              <img id="icon" *ngIf="menu.icon" [src]="menu.icon" />
            </div>
            &nbsp; <span>{{ menu.name }}</span>

            <!-- Toggle icon based on submenu visibility -->
            <span *ngIf="menu.isToggleMenu" class="ms-3-vw">
              <i
                class="fa-solid"
                [ngClass]="
                  menu.subMenuVisible ? 'fa-chevron-down' : 'fa-chevron-right'
                "
              ></i>
            </span>
          </li>

          <!-- Submenu items -->
          <ng-container *ngIf="menu.subMenuVisible && menu.subMenu?.length">
            <ng-container *ngFor="let subMenu of menu.subMenu">
              <li
                *ngIf="subMenu.isVisible"
                class="d-flex align-items-center fw-600 ms-4-vw fs-13-vw"
                style="overflow-wrap: anywhere"
                (click)="
                  subMenu.isToggleMenu
                    ? (subMenu.subMenuVisible = !subMenu.subMenuVisible)
                    : routeChange(subMenu?.routerLink)
                "
                [class.active]="isActive(subMenu?.routerLink)"
                [ngClass]="{ activeeleemnt: subMenu.subMenuVisible }"
              >
                <div class="ms-2-vw">
                  <img id="icon" *ngIf="subMenu.icon" [src]="subMenu.icon" />
                </div>
                &nbsp; <span>{{ subMenu.name }}</span>
                <span *ngIf="subMenu.isToggleMenu" class="ms-3-vw">
                  <i
                    class="fa-solid"
                    [ngClass]="
                      subMenu.subMenuVisible
                        ? 'fa-chevron-down'
                        : 'fa-chevron-right'
                    "
                  ></i>
                </span>
              </li>

              <!-- Nested Submenu items -->
              <ng-container
                *ngIf="
                  subMenu.subMenuVisible && subMenu.nestedSubMenu?.length > 0
                "
              >
                <ng-container
                  *ngFor="let nestedSubMenu of subMenu.nestedSubMenu"
                >
                  <ol
                    *ngIf="nestedSubMenu.isVisible"
                    class="d-flex align-items-center fw-600 ms-4-vw ps-3-vw fs-13-vw nested-menu-list"
                    style="overflow-wrap: anywhere"
                    (click)="routeChange(nestedSubMenu.routerLink)"
                    [class.active]="isActive(nestedSubMenu?.routerLink)"
                  >
                    <div class="ms-2-vw">
                      <img
                        id="icon"
                        *ngIf="nestedSubMenu.icon"
                        [src]="nestedSubMenu.icon"
                      />
                    </div>
                    &nbsp;
                    <span>{{ nestedSubMenu.name }}</span>
                  </ol>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ul>

      <!-- <ul class="list-unstyled" style="position: absolute; bottom: 0">
      <li class="bottom-li d-flex justify-content-between align-items-center">
        <img src="{{ profile }}" alt="User Image" class="user-image me-2"
          onError="this.src='../../../../assets/images/default.jpg'" />
        <div class="name" style="width: 60%">
          <span class="user-email fs-16-vw">{{
            firstName ? firstName : userName
            }}</span>

          <span class="user-email fs-13-vw"> ( {{ role }} ) </span>
        </div>

        <img (click)="logOut()" src="../../../../assets/images/logout_logo.png" alt="Logout" class="logout-icon" />
      </li>
      <hr>
      <div class="d-flex justify-content-between align-items-center" style="width: 16vw;">
        <label class="fs-13-vw fw-600 text-white">Powered By</label>
        <img class="bottomLogo" src="../../assets/images/zoei_logo_white.png" alt="logo" />

      </div>
    </ul> -->

      <div style="bottom: 0.5rem; position: absolute; width: 100%">
        <div class="d-flex justify-content-between align-items-center mx-1-vw">
          <img
            src="{{ profile }}"
            alt="User Image"
            class="user-image me-2"
            onError="this.src='../../../../assets/images/default.jpg'"
          />
          <div class="name" style="width: 60%">
            <span class="user-email fs-16-vw">{{
              firstName ? firstName : userName
            }}</span>

            <span class="user-email fs-13-vw"> ( {{ role }} ) </span>
          </div>

          <img
            (click)="logOut()"
            src="../../../../assets/images/logout_logo.png"
            alt="Logout"
            class="logout-icon"
          />
        </div>
        <hr style="margin: 0.6rem 0" />
        <div class="d-flex justify-content-between align-items-center px-1-vw">
          <label
            class="fs-13-vw fw-600 text-white mx-2-vw"
            *ngIf="!consultantLogo"
            >Powered By</label
          >
          <img
            *ngIf="consultantLogo"
            style="width: 10vw; object-fit: contain"
            [src]="consultantLogo"
            alt="logo"
          />
          <img
            style="width: 5vw; object-fit: contain"
            src="../../assets/images/zoei_logo_white.png"
            alt="logo"
          />
        </div>
      </div>
    </div>
  </div>
</div>
